import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WINDOW } from '@bo-client/core/provider/window.provider';
import { AuthenticationService } from '@bo-client/core';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';

@Injectable()
export class UserLoggedInGuard {
  constructor(
    @Inject(WINDOW) private window: Window,
    private router: Router,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authenticationService.isLoggedIn) {
      this.router.navigate([this.authorizationService.selectRouteLogin()], {
        replaceUrl: true
      });
      return false;
    }
    return true;
  }
}
